import { render, staticRenderFns } from "./MemberDelegates.vue?vue&type=template&id=b663326c&scoped=true"
import script from "./MemberDelegates.vue?vue&type=script&lang=js"
export * from "./MemberDelegates.vue?vue&type=script&lang=js"
import style0 from "./MemberDelegates.vue?vue&type=style&index=0&id=b663326c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b663326c",
  null
  
)

export default component.exports